// extracted by mini-css-extract-plugin
export var coloredText = "SectionHighlightedDescription-module--coloredText--977e5";
export var disclaimer = "SectionHighlightedDescription-module--disclaimer--f9c5b";
export var highlightedContainer = "SectionHighlightedDescription-module--highlightedContainer--ac2e3";
export var simpleText = "SectionHighlightedDescription-module--simpleText--0a3aa";